// Import model
import { ReportDocumentTemplateCondition } from '../models/ReportDocumentTemplateCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ReportDocumentTemplateIndexedFields } from '../models/ReportDocumentTemplateIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ReportDocumentTemplateIndexedFieldsSerializer } from './ReportDocumentTemplateIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ReportDocumentTemplateCondition - handles JSON serialization and deserialization with type validation
 */
export class ReportDocumentTemplateConditionSerializer {
  /**
   * Deserializes a JSON string into a ReportDocumentTemplateCondition instance
   */
  static deserialize(json: string): ReportDocumentTemplateCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ReportDocumentTemplateCondition instance
   */
  static fromObject(obj: any): ReportDocumentTemplateCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ReportDocumentTemplateCondition');
    }


    const instance: ReportDocumentTemplateCondition = {
      fieldName: obj['fieldName'] as ReportDocumentTemplateIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ReportDocumentTemplateCondition instances
   */
  static deserializeArray(json: string): ReportDocumentTemplateCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ReportDocumentTemplateCondition instance to a JSON string
   */
  static serialize(instance: ReportDocumentTemplateCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ReportDocumentTemplateCondition instance to a plain object
   */
  static toObject(instance: ReportDocumentTemplateCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ReportDocumentTemplateCondition instances to a JSON string
   */
  static serializeArray(instances: ReportDocumentTemplateCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
